import { removeCookieValue, setCookieValue } from '@lingoda/cookie';
import { history } from '@lingoda/router';
import { getTopLevelDomain } from '@lingoda/urls';

export const COOKIE_CLASS_TOKEN_KEY = 'CLASS_TOKEN';

export function setAuthCookiesFromUrl() {
    const TOKEN_PARAM_NAME = 'token';

    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get(TOKEN_PARAM_NAME);
    if (!token) {
        return;
    }

    setCookieValue(COOKIE_CLASS_TOKEN_KEY, `Bearer ${token}`);
    urlSearchParams.delete(TOKEN_PARAM_NAME);
    history.replace({ search: urlSearchParams.toString() });
}

export function clearAuthCookies() {
    const domain = getTopLevelDomain();
    removeCookieValue(COOKIE_CLASS_TOKEN_KEY, { domain });
}
